module.exports = __webpack_public_path__ + "static/media/vtex-manual-import3.80e48c12.png";